export default __webpack_public_path__ + "static/hero-47812f40ea8bab4cc75083e1dd179164.mp4";